import { Banner, Box } from '@dtx-company/design-system/src'
import { FC } from 'react'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { defaultPageAttributes } from '@dtx-company/true-common/src/constants/page'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import { getAppBaseUrl } from '@dtx-company/true-common/src/utils/urls/getAppBaseUrl'
import { usePageCanBePublished } from '../../hooks/usePageCanBePublished'
import { useRouter } from 'next/router'

interface PublishBannerProps {
  pageId: string
}

const PublishBanner: FC<PublishBannerProps> = ({ pageId }) => {
  const router = useRouter()
  const entity = router.query.templateId ? 'template' : 'page'
  const isTempPage = pageId === defaultPageAttributes.id
  const userHasLinkAndBio = usePageCanBePublished()
  const baseUrl = getAppBaseUrl()

  const message = (() => {
    if (isTempPage) {
      if (userHasLinkAndBio)
        return 'This is a preview of your Flowpage. Click edit to go back to edit or publish your page.'
      else
        return 'This is a preview of your Flowpage. Click edit, then add a description and a link to get started.'
    } else {
      return `Currently viewing your live ${entity}`
    }
  })()

  return (
    <Box
      sx={theme => ({
        width: { xs: '100%', md: '50%' },
        alignSelf: 'center',
        m: { md: theme.spacing(0, 2, 0) },
        zIndex: 1,
        position: 'absolute',
        top: 8
      })}
    >
      <Banner
        description={message}
        buttonText="Edit"
        alignContent="center"
        buttonProps={{
          onClick: (): void => {
            fireAnalyticsEvent('Flowpage_PublishBanner_EditButton_Clicked')
            if (isTempPage) {
              router.query.templateId
                ? router.push({
                    query: { id: router.query.templateId, previewed: true },
                    pathname: Routes.PAGE_TEMPLATE_EDITOR
                  })
                : router.push({
                    query: { previewed: true, id: pageId },
                    pathname: Routes.PAGE_EDITOR
                  })
            }
          },
          // published page banner will be on flow.page, so we need to use href
          ...(!isTempPage && {
            href: router.query.templateId
              ? `${baseUrl}/pages/templates/${router.query.templateId}?previewed=true`
              : `${baseUrl}/pages/${pageId}?previewed=true`
          })
        }}
      />
    </Box>
  )
}

export default PublishBanner
